import { Union } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { class_type, union_type, string_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { PageCode, TranslationsModule_Empty, TranslationKey, TagCode } from "../Shopfoo.Domain.Types/Translations.js";
import { orElse, defaultArgWith, unwrap, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { containsKey, FSharpMap__get_IsEmpty, FSharpMap__get_Count, empty, tryFind } from "../fable_modules/fable-library-js.4.24.0/Map.js";
import { safeHash, equals, int32ToString, defaultOf, compare } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { join, format as format_1, interpolate, toText } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { second, minute, hour } from "../fable_modules/fable-library-js.4.24.0/Date.js";
import { filter, head, map, toArray, singleton, empty as empty_1, collect, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { split } from "../fable_modules/fable-library-js.4.24.0/RegExp.js";
import { day, year, month } from "../fable_modules/fable-library-js.4.24.0/DateOnly.js";
import { ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { distinct, groupBy } from "../fable_modules/fable-library-js.4.24.0/Seq2.js";
import { FSharpSet__Contains, ofSeq, FSharpSet__get_IsEmpty } from "../fable_modules/fable-library-js.4.24.0/Set.js";
import { Option_ofBool } from "../Shopfoo.Common/Common.js";

export class DatePartFormat extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["DayInMonth", "MonthShortName", "Year", "Separator"];
    }
}

export function DatePartFormat_$reflection() {
    return union_type("Shopfoo.Shared.Translations.DatePartFormat", [], DatePartFormat, () => [[], [], [], [["Item", string_type]]]);
}

export class TranslationPages_TranslationKeyBuilder {
    constructor(pageCode) {
        this.pageCode = pageCode;
    }
}

export function TranslationPages_TranslationKeyBuilder_$reflection() {
    return class_type("Shopfoo.Shared.Translations.TranslationPages.TranslationKeyBuilder", undefined, TranslationPages_TranslationKeyBuilder);
}

export function TranslationPages_TranslationKeyBuilder_$ctor_20836C2A(pageCode) {
    return new TranslationPages_TranslationKeyBuilder(pageCode);
}

export function TranslationPages_TranslationKeyBuilder__Create_Z721C83C5(_, tag) {
    return new TranslationKey(_.pageCode, new TagCode(tag));
}

export function TranslationPages_TranslationKeyBuilder__Error_Z721C83C5(this$, name) {
    return TranslationPages_TranslationKeyBuilder__Create_Z721C83C5(this$, `${name}Error`);
}

export function TranslationPages_TranslationKeyBuilder__ErrorOn_Z721C83C5(this$, action) {
    return TranslationPages_TranslationKeyBuilder__Create_Z721C83C5(this$, `Error${action}`);
}

export class TranslationPages_Base {
    constructor(pageCode, translations, buildTagCode) {
        this.pageCode = pageCode;
        this["buildTagCode@24"] = defaultArg(buildTagCode, (code) => (new TagCode(code)));
        this["translations@25"] = defaultArg(translations, TranslationsModule_Empty);
        this.tagMap = defaultArg(tryFind(this.pageCode, this["translations@25"].Pages), empty({
            Compare: compare,
        }));
        this["PageCode@"] = this.pageCode;
        this["Count@"] = (FSharpMap__get_Count(this.tagMap) | 0);
        this["IsEmpty@"] = FSharpMap__get_IsEmpty(this.tagMap);
    }
}

export function TranslationPages_Base_$reflection() {
    return class_type("Shopfoo.Shared.Translations.TranslationPages.Base", undefined, TranslationPages_Base);
}

export function TranslationPages_Base_$ctor_Z40962780(pageCode, translations, buildTagCode) {
    return new TranslationPages_Base(pageCode, translations, buildTagCode);
}

export function TranslationPages_Base__get_PageCode(__) {
    return __["PageCode@"];
}

export function TranslationPages_Base__get_Count(__) {
    return __["Count@"];
}

export function TranslationPages_Base__get_IsEmpty(__) {
    return __["IsEmpty@"];
}

export function TranslationPages_Base__TranslationPath_1B2242CB(_, _arg) {
    return toText(interpolate("%A%P().%s%P()", [_.pageCode, _arg.fields[0]]));
}

export function TranslationPages_Base__FallbackValue_1B2242CB(this$, tag) {
    return `[*** ${TranslationPages_Base__TranslationPath_1B2242CB(this$, tag)} ***]`;
}

export function TranslationPages_Base__Format_Z17053F5(this$, tag, ...args) {
    return format_1(TranslationPages_Base__Get_27AED5E3(this$, tag), ...args);
}

export function TranslationPages_Base__Get_27AED5E3(this$, tag, defaultValue) {
    return TranslationPages_Base__Get_12974A53(this$, this$["buildTagCode@24"](tag), unwrap(defaultValue));
}

export function TranslationPages_Base__Get_12974A53(this$, tagCode, defaultValue) {
    return defaultArgWith(orElse(TranslationPages_Base__GetOrNone_1B2242CB(this$, tagCode), defaultValue), () => TranslationPages_Base__FallbackValue_1B2242CB(this$, tagCode));
}

export function TranslationPages_Base__GetOrNone_Z721C83C5(this$, tag) {
    return TranslationPages_Base__GetOrNone_1B2242CB(this$, this$["buildTagCode@24"](tag));
}

export function TranslationPages_Base__GetOrNone_1B2242CB(this$, tagCode) {
    return tryFind(tagCode, this$.tagMap);
}

export function TranslationPages_Base__WithPrefix(this$, tagPrefix, useNesting) {
    return useNesting(TranslationPages_Base_$ctor_Z40962780(this$.pageCode, this$["translations@25"], (tag) => this$["buildTagCode@24"](`${tagPrefix}${tag}`)));
}

export class TranslationPages_Home extends TranslationPages_Base {
    constructor(translations) {
        super(new PageCode(0, []), unwrap(translations));
    }
}

export function TranslationPages_Home_$reflection() {
    return class_type("Shopfoo.Shared.Translations.TranslationPages.Home", undefined, TranslationPages_Home, TranslationPages_Base_$reflection());
}

export function TranslationPages_Home_$ctor_Z4CA92FD1(translations) {
    return new TranslationPages_Home(translations);
}

export function TranslationPages_Home__get_About(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "About");
}

export function TranslationPages_Home__get_AboutDisclaimer(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "AboutDisclaimer");
}

export function TranslationPages_Home__get_Admin(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "Admin");
}

export function TranslationPages_Home__get_AdminDisclaimer(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "AdminDisclaimer");
}

export function TranslationPages_Home__get_Bazaar(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "Bazaar");
}

export function TranslationPages_Home__get_Books(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "Books");
}

export function TranslationPages_Home__get_Login(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "Login");
}

export function TranslationPages_Home__get_Logout(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "Logout");
}

export function TranslationPages_Home__get_Page(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "Page");
}

export function TranslationPages_Home__get_Product(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "Product");
}

export function TranslationPages_Home__get_Products(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "Products");
}

export function TranslationPages_Home__get_SelectedPlural(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "SelectedPlural");
}

export function TranslationPages_Home__get_ProductCache(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "ProductCache");
}

export function TranslationPages_Home__get_ConfirmReset(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "ConfirmReset");
}

export function TranslationPages_Home__get_ConfirmResetCacheMessage(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "ConfirmResetCacheMessage");
}

export function TranslationPages_Home__get_ResetProductCache(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "ResetProductCache");
}

export function TranslationPages_Home__get_ResetProductCacheDisclaimer(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "ResetProductCacheDisclaimer");
}

export function TranslationPages_Home__ResetProductCacheSuccess_7F9DDECF(this$, dateTime) {
    return TranslationPages_Base__Format_Z17053F5(this$, "ResetProductCacheSuccess", `${hour(dateTime)}`, toText(interpolate("%02i%P()", [minute(dateTime)])), toText(interpolate("%02i%P()", [second(dateTime)])));
}

export function TranslationPages_Home__get_Add(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "Add");
}

export function TranslationPages_Home__get_Cancel(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "Cancel");
}

export function TranslationPages_Home__get_Clear(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "Clear");
}

export function TranslationPages_Home__get_Close(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "Close");
}

export function TranslationPages_Home__get_Save(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "Save");
}

export function TranslationPages_Home__get_Search(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "Search");
}

export function TranslationPages_Home__get_SearchOrAdd(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "SearchOrAdd");
}

export function TranslationPages_Home__get_Confirmation(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "Confirmation");
}

export function TranslationPages_Home__get_Completed(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "Completed");
}

export function TranslationPages_Home__Error_Z721C83C5(this$, error) {
    return TranslationPages_Base__Format_Z17053F5(this$, "Error", error);
}

export function TranslationPages_Home__SavedOk_Z721C83C5(this$, name) {
    return TranslationPages_Base__Format_Z17053F5(this$, "SavedOk", name);
}

export function TranslationPages_Home__SavedError_Z384F8060(this$, name, error) {
    return TranslationPages_Base__Format_Z17053F5(this$, "SavedError", name, error);
}

export function TranslationPages_Home__get_Warning(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "Warning");
}

export function TranslationPages_Home__get_Colon(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "Colon");
}

export function TranslationPages_Home__get_Date(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "Date");
}

export function TranslationPages_Home__get_Required(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "Required");
}

export function TranslationPages_Home__ChangeLangError_Z384F8060(this$, lang, error) {
    return TranslationPages_Base__Format_Z17053F5(this$, "ChangeLangError", lang, error);
}

export function TranslationPages_Home__get_ChangeLangOk(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "ChangeLangOk");
}

export function TranslationPages_Home__ErrorNotFound_Z721C83C5(this$, what) {
    return TranslationPages_Base__Format_Z17053F5(this$, "ErrorNotFound", what);
}

function TranslationPages_Home__get_DayInMonth(this$) {
    return (_arg) => ((_arg === 1) ? TranslationPages_Base__Get_27AED5E3(this$, "DayInMonth.1st") : ((_arg === 2) ? TranslationPages_Base__Get_27AED5E3(this$, "DayInMonth.2nd") : ((_arg === 3) ? TranslationPages_Base__Get_27AED5E3(this$, "DayInMonth.3rd") : ((_arg === 4) ? TranslationPages_Base__Get_27AED5E3(this$, "DayInMonth.4th") : ((_arg === 5) ? TranslationPages_Base__Get_27AED5E3(this$, "DayInMonth.5th") : ((_arg === 6) ? TranslationPages_Base__Get_27AED5E3(this$, "DayInMonth.6th") : ((_arg === 7) ? TranslationPages_Base__Get_27AED5E3(this$, "DayInMonth.7th") : ((_arg === 8) ? TranslationPages_Base__Get_27AED5E3(this$, "DayInMonth.8th") : ((_arg === 9) ? TranslationPages_Base__Get_27AED5E3(this$, "DayInMonth.9th") : ((_arg === 10) ? TranslationPages_Base__Get_27AED5E3(this$, "DayInMonth.10th") : ((_arg === 11) ? TranslationPages_Base__Get_27AED5E3(this$, "DayInMonth.11th") : ((_arg === 12) ? TranslationPages_Base__Get_27AED5E3(this$, "DayInMonth.12th") : ((_arg === 13) ? TranslationPages_Base__Get_27AED5E3(this$, "DayInMonth.13th") : ((_arg === 14) ? TranslationPages_Base__Get_27AED5E3(this$, "DayInMonth.14th") : ((_arg === 15) ? TranslationPages_Base__Get_27AED5E3(this$, "DayInMonth.15th") : ((_arg === 16) ? TranslationPages_Base__Get_27AED5E3(this$, "DayInMonth.16th") : ((_arg === 17) ? TranslationPages_Base__Get_27AED5E3(this$, "DayInMonth.17th") : ((_arg === 18) ? TranslationPages_Base__Get_27AED5E3(this$, "DayInMonth.18th") : ((_arg === 19) ? TranslationPages_Base__Get_27AED5E3(this$, "DayInMonth.19th") : ((_arg === 20) ? TranslationPages_Base__Get_27AED5E3(this$, "DayInMonth.20th") : ((_arg === 21) ? TranslationPages_Base__Get_27AED5E3(this$, "DayInMonth.21st") : ((_arg === 22) ? TranslationPages_Base__Get_27AED5E3(this$, "DayInMonth.22nd") : ((_arg === 23) ? TranslationPages_Base__Get_27AED5E3(this$, "DayInMonth.23rd") : ((_arg === 24) ? TranslationPages_Base__Get_27AED5E3(this$, "DayInMonth.24th") : ((_arg === 25) ? TranslationPages_Base__Get_27AED5E3(this$, "DayInMonth.25th") : ((_arg === 26) ? TranslationPages_Base__Get_27AED5E3(this$, "DayInMonth.26th") : ((_arg === 27) ? TranslationPages_Base__Get_27AED5E3(this$, "DayInMonth.27th") : ((_arg === 28) ? TranslationPages_Base__Get_27AED5E3(this$, "DayInMonth.28th") : ((_arg === 29) ? TranslationPages_Base__Get_27AED5E3(this$, "DayInMonth.29th") : ((_arg === 30) ? TranslationPages_Base__Get_27AED5E3(this$, "DayInMonth.30th") : ((_arg === 31) ? TranslationPages_Base__Get_27AED5E3(this$, "DayInMonth.31st") : "")))))))))))))))))))))))))))))));
}

function TranslationPages_Home__get_ShortMonth(this$) {
    return (_arg) => ((_arg === 1) ? TranslationPages_Base__Get_27AED5E3(this$, "ShortMonth.Jan") : ((_arg === 2) ? TranslationPages_Base__Get_27AED5E3(this$, "ShortMonth.Feb") : ((_arg === 3) ? TranslationPages_Base__Get_27AED5E3(this$, "ShortMonth.Mar") : ((_arg === 4) ? TranslationPages_Base__Get_27AED5E3(this$, "ShortMonth.Apr") : ((_arg === 5) ? TranslationPages_Base__Get_27AED5E3(this$, "ShortMonth.May") : ((_arg === 6) ? TranslationPages_Base__Get_27AED5E3(this$, "ShortMonth.Jun") : ((_arg === 7) ? TranslationPages_Base__Get_27AED5E3(this$, "ShortMonth.Jul") : ((_arg === 8) ? TranslationPages_Base__Get_27AED5E3(this$, "ShortMonth.Aug") : ((_arg === 9) ? TranslationPages_Base__Get_27AED5E3(this$, "ShortMonth.Sep") : ((_arg === 10) ? TranslationPages_Base__Get_27AED5E3(this$, "ShortMonth.Oct") : ((_arg === 11) ? TranslationPages_Base__Get_27AED5E3(this$, "ShortMonth.Nov") : ((_arg === 12) ? TranslationPages_Base__Get_27AED5E3(this$, "ShortMonth.Dec") : ""))))))))))));
}

/**
 * Parse the format parts from the translation, e.g. "DayInMonth ShortMonth, Year" -> [DayInMonth; Separator " "; ShortMonth; Separator ", "; Year]
 */
export function TranslationPages_Home__get_StandardDateFormat(this$) {
    return toList(delay(() => collect((part) => {
        const matchValue = part;
        let matchResult;
        if (matchValue === defaultOf()) {
            matchResult = 0;
        }
        else {
            switch (matchValue) {
                case "": {
                    matchResult = 0;
                    break;
                }
                case "DDD":
                case "DayInMonth": {
                    matchResult = 1;
                    break;
                }
                case "MMM":
                case "ShortMonth": {
                    matchResult = 2;
                    break;
                }
                case "YYYY":
                case "Year": {
                    matchResult = 3;
                    break;
                }
                default:
                    matchResult = 4;
            }
        }
        switch (matchResult) {
            case 0: {
                return empty_1();
            }
            case 1:
                return singleton(new DatePartFormat(0, []));
            case 2:
                return singleton(new DatePartFormat(1, []));
            case 3:
                return singleton(new DatePartFormat(2, []));
            default:
                return singleton(new DatePartFormat(3, [matchValue]));
        }
    }, split(TranslationPages_Base__Get_27AED5E3(this$, "StandardDateFormat"), "(DayInMonth|DDD|ShortMonth|MMM|Year|YYYY)"))));
}

export function TranslationPages_Home__FormatDate_137ECF4(this$, date, format) {
    return join("", toList(delay(() => collect((part) => {
        const matchValue = part;
        return (matchValue.tag === 1) ? singleton(TranslationPages_Home__get_ShortMonth(this$)(month(date))) : ((matchValue.tag === 2) ? singleton(int32ToString(year(date))) : ((matchValue.tag === 3) ? singleton(matchValue.fields[0]) : singleton(TranslationPages_Home__get_DayInMonth(this$)(day(date)))));
    }, format))));
}

export function TranslationPages_Home__get_Theme(this$) {
    return TranslationPages_Base__WithPrefix(this$, "Theme.", (this$_1) => {
        const Dark = TranslationPages_Base__Get_27AED5E3(this$_1, "Dark");
        const Light = TranslationPages_Base__Get_27AED5E3(this$_1, "Light");
        const Business = TranslationPages_Base__Get_27AED5E3(this$_1, "Business");
        const Corporate = TranslationPages_Base__Get_27AED5E3(this$_1, "Corporate");
        const Garden = TranslationPages_Base__Get_27AED5E3(this$_1, "Garden");
        const Night = TranslationPages_Base__Get_27AED5E3(this$_1, "Night");
        const Nord = TranslationPages_Base__Get_27AED5E3(this$_1, "Nord");
        return {
            Business: Business,
            Corporate: Corporate,
            Dark: Dark,
            Dim: TranslationPages_Base__Get_27AED5E3(this$_1, "Dim"),
            Garden: Garden,
            Light: Light,
            Night: Night,
            Nord: Nord,
        };
    });
}

export function TranslationPages_Home__get_ThemeGroup(this$) {
    return TranslationPages_Base__WithPrefix(this$, "ThemeGroup.", (this$_1) => ({
        Dark: TranslationPages_Base__Get_27AED5E3(this$_1, "Dark"),
        Light: TranslationPages_Base__Get_27AED5E3(this$_1, "Light"),
    }));
}

export class TranslationPages_Login extends TranslationPages_Base {
    constructor(translations) {
        super(new PageCode(1, []), unwrap(translations));
    }
}

export function TranslationPages_Login_$reflection() {
    return class_type("Shopfoo.Shared.Translations.TranslationPages.Login", undefined, TranslationPages_Login, TranslationPages_Base_$reflection());
}

export function TranslationPages_Login_$ctor_Z4CA92FD1(translations) {
    return new TranslationPages_Login(translations);
}

export function TranslationPages_Login__get_Access(this$) {
    return TranslationPages_Base__WithPrefix(this$, "Access.", (this$_1) => ({
        Edit: TranslationPages_Base__Get_27AED5E3(this$_1, "Edit"),
        View: TranslationPages_Base__Get_27AED5E3(this$_1, "View"),
    }));
}

export function TranslationPages_Login__get_Feat(this$) {
    return TranslationPages_Base__WithPrefix(this$, "Feat.", (this$_1) => ({
        About: TranslationPages_Base__Get_27AED5E3(this$_1, "About"),
        Admin: TranslationPages_Base__Get_27AED5E3(this$_1, "Admin"),
        Catalog: TranslationPages_Base__Get_27AED5E3(this$_1, "Catalog"),
        Sales: TranslationPages_Base__Get_27AED5E3(this$_1, "Sales"),
        Warehouse: TranslationPages_Base__Get_27AED5E3(this$_1, "Warehouse"),
    }));
}

export function TranslationPages_Login__get_SelectPersona(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "SelectPersona");
}

export function TranslationPages_Login__get_Persona(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "Persona");
}

export class TranslationPages_Product extends TranslationPages_Base {
    constructor(translations) {
        super(new PageCode(2, []), unwrap(translations));
    }
}

export function TranslationPages_Product_$reflection() {
    return class_type("Shopfoo.Shared.Translations.TranslationPages.Product", undefined, TranslationPages_Product, TranslationPages_Base_$reflection());
}

export function TranslationPages_Product_$ctor_Z4CA92FD1(translations) {
    return new TranslationPages_Product(translations);
}

export function TranslationPages_Product__get_Actions(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "Actions");
}

export function TranslationPages_Product__get_Authors(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "Authors");
}

export function TranslationPages_Product__get_CatalogInfo(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "CatalogInfo");
}

export function TranslationPages_Product__get_Category(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "Category");
}

export function TranslationPages_Product__get_Description(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "Description");
}

export function TranslationPages_Product__get_HighlightMatches(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "HighlightMatches");
}

export function TranslationPages_Product__get_MatchCase(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "MatchCase");
}

export function TranslationPages_Product__get_ImageUrl(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "ImageUrl");
}

export function TranslationPages_Product__get_Name(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "Name");
}

export function TranslationPages_Product__get_NewProductTitle(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "NewProductTitle");
}

export function TranslationPages_Product__get_NewProductDisclaimer(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "NewProductDisclaimer");
}

export function TranslationPages_Product__get_SoldOut(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "SoldOut");
}

export function TranslationPages_Product__get_Subtitle(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "Subtitle");
}

export function TranslationPages_Product__get_Tags(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "Tags");
}

export function TranslationPages_Product__get_AddTag(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "AddTag");
}

export function TranslationPages_Product__get_SearchAuthors(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "SearchAuthors");
}

export function TranslationPages_Product__get_NoAuthorsFound(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "NoAuthorsFound");
}

export function TranslationPages_Product__AuthorSearchLimit_Z37302880(this$, limit, totalFound) {
    return TranslationPages_Base__Format_Z17053F5(this$, "AuthorSearchLimit", limit, totalFound);
}

export function TranslationPages_Product__get_SearchBooks(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "SearchBooks");
}

export function TranslationPages_Product__get_NoBooksFound(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "NoBooksFound");
}

export function TranslationPages_Product__BookSearchLimit_Z37302880(this$, limit, totalFound) {
    return TranslationPages_Base__Format_Z17053F5(this$, "BookSearchLimit", limit, totalFound);
}

export function TranslationPages_Product__OpenLibraryAuthorPage_Z721C83C5(this$, authorName) {
    return TranslationPages_Base__Format_Z17053F5(this$, "OpenLibraryAuthorPage", authorName);
}

export function TranslationPages_Product__get_Discount(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "Discount");
}

export function TranslationPages_Product__get_Margin(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "Margin");
}

export function TranslationPages_Product__get_Quantity(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "Quantity");
}

export function TranslationPages_Product__get_Increase(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "Increase");
}

export function TranslationPages_Product__get_Decrease(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "Decrease");
}

export function TranslationPages_Product__get_Define(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "Define");
}

export function TranslationPages_Product__get_CurrentPrice(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "CurrentPrice");
}

export function TranslationPages_Product__get_Price(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "Price");
}

export function TranslationPages_Product__get_NewPrice(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "NewPrice");
}

export function TranslationPages_Product__get_ListPrice(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "ListPrice");
}

export function TranslationPages_Product__get_RetailPrice(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "RetailPrice");
}

export function TranslationPages_Product__get_SalePrice(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "SalePrice");
}

export function TranslationPages_Product__get_AverageOver1Y(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "AverageOver1Y");
}

export function TranslationPages_Product__get_LastPurchase(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "LastPurchase");
}

export function TranslationPages_Product__get_LastSale(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "LastSale");
}

export function TranslationPages_Product__get_TotalSalesOver1Y(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "TotalSalesOver1Y");
}

export function TranslationPages_Product__get_PriceAction(this$) {
    return TranslationPages_Base__WithPrefix(this$, "PriceAction.", (this$_1) => {
        const Define = TranslationPages_Base__Get_27AED5E3(this$_1, "Define");
        const Remove = TranslationPages_Base__Get_27AED5E3(this$_1, "Remove");
        const Increase = TranslationPages_Base__Get_27AED5E3(this$_1, "Increase");
        const Decrease = TranslationPages_Base__Get_27AED5E3(this$_1, "Decrease");
        const MarkAsSoldOut = TranslationPages_Base__Get_27AED5E3(this$_1, "MarkAsSoldOut");
        const WarnMarkAsSoldOutForbidden = TranslationPages_Base__Get_27AED5E3(this$_1, "WarnMarkAsSoldOutForbidden");
        return {
            Decrease: Decrease,
            Define: Define,
            Increase: Increase,
            MarkAsSoldOut: MarkAsSoldOut,
            MarkAsSoldOutDialog: TranslationPages_Base__WithPrefix(this$_1, "MarkAsSoldOutDialog.", (this$_2) => ({
                Confirm: TranslationPages_Base__Get_27AED5E3(this$_2, "Confirm"),
                Question: TranslationPages_Base__Get_27AED5E3(this$_2, "Question"),
            })),
            Remove: Remove,
            RemoveListPriceDialog: TranslationPages_Base__WithPrefix(this$_1, "RemoveListPriceDialog.", (this$_3) => ({
                Confirm: TranslationPages_Base__Get_27AED5E3(this$_3, "Confirm"),
                Question: TranslationPages_Base__Get_27AED5E3(this$_3, "Question"),
            })),
            WarnMarkAsSoldOutForbidden: WarnMarkAsSoldOutForbidden,
        };
    });
}

export function TranslationPages_Product__get_StoreCategory(this$) {
    return TranslationPages_Base__WithPrefix(this$, "StoreCategory.", (this$_1) => ({
        Clothing: TranslationPages_Base__Get_27AED5E3(this$_1, "Clothing"),
        Electronics: TranslationPages_Base__Get_27AED5E3(this$_1, "Electronics"),
        Jewelry: TranslationPages_Base__Get_27AED5E3(this$_1, "Jewelry"),
    }));
}

export function TranslationPages_Product__StoreCategoryOf_Z2CEE261C(this$, storeCategory) {
    switch (storeCategory.tag) {
        case 1:
            return TranslationPages_Product__get_StoreCategory(this$).Electronics;
        case 2:
            return TranslationPages_Product__get_StoreCategory(this$).Jewelry;
        default:
            return TranslationPages_Product__get_StoreCategory(this$).Clothing;
    }
}

export function TranslationPages_Product__get_Stock(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "Stock");
}

export function TranslationPages_Product__get_StockAfterInventory(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "StockAfterInventory");
}

export function TranslationPages_Product__get_StockBeforeInventory(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "StockBeforeInventory");
}

export function TranslationPages_Product__get_SupplyDate(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "SupplyDate");
}

export function TranslationPages_Product__get_SupplyQuantity(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "SupplyQuantity");
}

export function TranslationPages_Product__get_SupplyPurchasePrice(this$) {
    return TranslationPages_Base__Get_27AED5E3(this$, "SupplyPurchasePrice");
}

export function TranslationPages_Product__get_StockAction(this$) {
    return TranslationPages_Base__WithPrefix(this$, "StockAction.", (this$_1) => ({
        AdjustStockAfterInventory: TranslationPages_Base__Get_27AED5E3(this$_1, "AdjustStockAfterInventory"),
        ReceivePurchasedProducts: TranslationPages_Base__Get_27AED5E3(this$_1, "ReceivePurchasedProducts"),
    }));
}

export function TranslationPages_Product__get_SaleAction(this$) {
    return TranslationPages_Base__WithPrefix(this$, "SaleAction.", (this$_1) => ({
        InputSales: TranslationPages_Base__Get_27AED5E3(this$_1, "InputSales"),
    }));
}

class Section extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["Section"];
    }
}

function Section_$reflection() {
    return union_type("Shopfoo.Shared.Translations.Section", [], Section, () => [[["Item", string_type]]]);
}

function Section_get_Home() {
    return new Section("Home");
}

function Section_get_Login() {
    return new Section("Login");
}

function Section_get_Product() {
    return new Section("Product");
}

export class AppTranslations {
    constructor(home, login, product, translations) {
        this.home = home;
        this.login = login;
        this.product = product;
        this.sections = ofArray([[Section_get_Home(), this.home], [Section_get_Login(), this.login], [Section_get_Product(), this.product]]);
        this["Home@"] = this.home;
        this["Login@"] = this.login;
        this["Product@"] = this.product;
        this["Translations@"] = defaultArg(translations, TranslationsModule_Empty);
        this["EmptyPages@"] = AppTranslations__pageCodes_ZA9F16EC(this, TranslationPages_Base__get_IsEmpty);
        this["PopulatedPages@"] = AppTranslations__pageCodes_ZA9F16EC(this, (x) => !TranslationPages_Base__get_IsEmpty(x));
        this["DebugInfo@"] = toArray(map((tupledArg_1) => {
            const pageCode = tupledArg_1[0];
            const infos = tupledArg_1[1];
            const count = head(map((arg) => TranslationPages_Base__get_Count(arg[1]), infos)) | 0;
            const sections = join(", ", map((tupledArg_2) => tupledArg_2[0].fields[0], infos));
            return toText(interpolate("%A%P() (%i%P())%s%P()", [pageCode, count, (sections !== toText(interpolate("%A%P()", [pageCode]))) ? (` [${sections}]`) : ""]));
        }, groupBy((tupledArg) => TranslationPages_Base__get_PageCode(tupledArg[1]), this.sections, {
            Equals: equals,
            GetHashCode: safeHash,
        })));
    }
}

export function AppTranslations_$reflection() {
    return class_type("Shopfoo.Shared.Translations.AppTranslations", undefined, AppTranslations);
}

function AppTranslations_$ctor_60223EF5(home, login, product, translations) {
    return new AppTranslations(home, login, product, translations);
}

export function AppTranslations_$ctor() {
    return AppTranslations_$ctor_60223EF5(TranslationPages_Home_$ctor_Z4CA92FD1(), TranslationPages_Login_$ctor_Z4CA92FD1(), TranslationPages_Product_$ctor_Z4CA92FD1());
}

export function AppTranslations__get_Home(__) {
    return __["Home@"];
}

export function AppTranslations__get_Login(__) {
    return __["Login@"];
}

export function AppTranslations__get_Product(__) {
    return __["Product@"];
}

export function AppTranslations__get_Translations(__) {
    return __["Translations@"];
}

export function AppTranslations__Fill_4099B01(this$, appTranslations) {
    return AppTranslations__Fill_Z288CEB4(this$, AppTranslations__get_Translations(appTranslations));
}

export function AppTranslations__Fill_Z288CEB4(_, translations) {
    const recreatePageIfNeeded = (page, createPage) => {
        if (containsKey(TranslationPages_Base__get_PageCode(page), translations.Pages)) {
            return createPage();
        }
        else {
            return page;
        }
    };
    return AppTranslations_$ctor_60223EF5(recreatePageIfNeeded(_.home, () => TranslationPages_Home_$ctor_Z4CA92FD1(translations)), recreatePageIfNeeded(_.login, () => TranslationPages_Login_$ctor_Z4CA92FD1(translations)), recreatePageIfNeeded(_.product, () => TranslationPages_Product_$ctor_Z4CA92FD1(translations)), translations);
}

export function AppTranslations__get_EmptyPages(__) {
    return __["EmptyPages@"];
}

export function AppTranslations__get_PopulatedPages(__) {
    return __["PopulatedPages@"];
}

export function AppTranslations__get_IsEmpty(this$) {
    return FSharpSet__get_IsEmpty(AppTranslations__get_PopulatedPages(this$));
}

export function AppTranslations__get_DebugInfo(__) {
    return __["DebugInfo@"];
}

export function AppTranslations__pageCodes_ZA9F16EC(this$, predicate) {
    return ofSeq(map(TranslationPages_Base__get_PageCode, filter(predicate, distinct(map((tuple) => tuple[1], this$.sections), {
        Equals: equals,
        GetHashCode: safeHash,
    }))), {
        Compare: compare,
    });
}

export function $007CTranslationsMissing$007C_$007C(pageCode, translations) {
    return Option_ofBool(!FSharpSet__Contains(AppTranslations__get_PopulatedPages(translations), pageCode));
}

